import * as React from "react";
import { cn } from "../../lib/cn.js";

export const ActionButtonGroup = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex shrink-0 flex-wrap items-center gap-1.5", className)}
    {...props}
  />
));
ActionButtonGroup.displayName = "ActionButtonGroup";
